import { Router } from "Router";
import Header from "components/layouts/header/Header/Header";
import ValidateDialog from "components/molecules/dialogs/ValidateDialog/ValidateDialog";
import { useRef, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { styled } from "styled-components";
import { Context } from "utils/Context";

function App() {
  const dialogText = useRef<string>("");
  const [dialogShow, setDialogShow] = useState<boolean>(false);
  const setDialog = (text: string, isShow: boolean) => {
    setDialogShow(isShow);
    dialogText.current = text;
  };
  return (
    <Context.Provider value={{ setDialog }}>
      <AppLayout>
        <BrowserRouter>
          <Header/>
          <RouterContainer>
            <Router />
          </RouterContainer>
          <ValidateDialog
            dialogShow={dialogShow}
            dialogText={dialogText.current}
            handleDialog={() => setDialogShow(false)}
          />
        </BrowserRouter>
      </AppLayout>
    </Context.Provider>
  );
}

const AppLayout = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const RouterContainer = styled.div`
  height: calc(100vh - 100px);
`;

export default App;
